<template>
    <div class="page">
        <h3 style="text-align: center;margin-bottom: 0;">
            <template v-if="lodash.isEmpty(letter4.nameOfCourt)">
                [<span style="background-color: #fbff1d;">COMPLETE NAME OF COURT</span>]
            </template>
            <template v-else>
                {{ letter4.nameOfCourt }}
            </template>
        </h3>
        <h3 style="text-align: center;margin-top: 0;">
            <template v-if="lodash.isEmpty(letter4.yourState)">
                STATE OF [<span style="background-color: #fbff1d;">YOUR STATE</span>]
            </template>
            <template v-else>
                STATE OF {{ letter4.yourState }}
            </template>
        </h3>
        <table  cellspacing="0" cellpadding="0" style="width: 100%;border: none;">
            <tr>
                <td style="width: 50%;border: none;">{{ userStore.user.firstname }} {{ userStore.user.lastname }},</td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;"></td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;text-align: center;">Plaintiff,</td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;"></td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;">v.</td>
                <td style="width: 50%;border: none;">
                    )
                    <span style="margin-left: 10rem;">
                        <template v-if="lodash.isEmpty(letter4.caseNumber)">
                            Case No. [<span style="background-color: #fbff1d;">case number</span>]
                        </template>
                        <template v-else>
                            Case No. {{ letter4.caseNumber }}
                        </template>
                    </span>
                </td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;"></td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;">{{ creditor.creditor_name }},</td>
                <td style="width: 50%;border: none;">
                    )
                    <span style="margin-left: 10rem;"><b>COMPLAINT</b></span>
                </td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;"></td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
            <tr>
                <td style="width: 50%;border: none;text-align: center;">Defendant.</td>
                <td style="width: 50%;border: none;">)</td>
            </tr>
        </table>
        <ol>
            <li>
                This Court has jurisdiction over Defendant because Defendant is a resident of 
                <template v-if="lodash.isEmpty(letter4.county)">
                    [<span style="background-color: #fbff1d;">County</span>]
                </template>
                <template v-else>
                    {{ letter4.county }}
                </template>
                County,
                <template v-if="lodash.isEmpty(letter4.state)">
                    [<span style="background-color: #fbff1d;">State</span>].
                </template>
                <template v-else>
                    {{ letter4.state }}.
                </template>
            </li>
            <li>
                Defendant has repossessed an automobile from Plaintiff and sold it at a sale.
            </li>
            <li>
                Defendant did not sale the collateral in a commercially reasonable manner.
            </li>
            <li>
                Defendant is attempting to collect a 
                <template v-if="lodash.isEmpty(letter4.deficiencyAmount)">
                    $[<span style="background-color: #fbff1d;">XX,XXX</span>]
                </template>
                <template v-else>
                    ${{ letter4.deficiencyAmount }}
                </template>
                deficiency from Plaintiff.
            </li>
            <li>
                Plaintiff is not legally liable to Defendant for a 
                <template v-if="lodash.isEmpty(letter4.deficiencyAmount)">
                    $[<span style="background-color: #fbff1d;">XX,XXX</span>]
                </template>
                <template v-else>
                    ${{ letter4.deficiencyAmount }}
                </template>
                 deficiency balance.
            </li>
            <li>
                Defendant failed to provide written and signed notice to Plaintiff of Defendant’s intent to sale Plaintiff’s automobile as collateral to a financial obligation and claim any deficiency.
            </li>
            <li>
                Defendant failed to send Plaintiff an explanation of calculation of deficiency after disposition of the collateral and before Defendant attempted to collect deficiency from Plaintiff.
            </li>
            <li>
                Defendant violated UCC § 9-610, UCC § 9-611, UCC § 9-614, UCC § 9-616, and can be restrained from collection of the alleged 
                <template v-if="lodash.isEmpty(letter4.deficiencyAmount)">
                    $[<span style="background-color: #fbff1d;">XX,XXX</span>]
                </template>
                <template v-else>
                    ${{ letter4.deficiencyAmount }}
                </template>
                deficiency under UCC § 9-625(a).
            </li>
            <li>
                Defendant violated 15 U.S.C. § 1692f(1) by attempting to collect a 
                <template v-if="lodash.isEmpty(letter4.deficiencyAmount)">
                    $[<span style="background-color: #fbff1d;">XX,XXX</span>]
                </template>
                <template v-else>
                    ${{ letter4.deficiencyAmount }}
                </template>
                 deficiency balance from Plaintiff that is not permitted by law.
            </li>
            <li>
                Plaintiff has suffered damages and Defendant is liable to Plaintiff for said damages.
            </li>
        </ol>
        <p style="margin-left: 1rem;">
            WHEREFORE, Plaintiff pray for damages in the amount of 
            <template v-if="lodash.isEmpty(letter4.courtAmountLimit)">
                $[<span style="background-color: #fbff1d;">dollar limit of court</span>]
            </template>
            <template v-else>
                ${{ letter4.courtAmountLimit }}
            </template>
            , plus 
            <template v-if="lodash.isEmpty(letter4.cost)">
                $[<span style="background-color: #fbff1d;">costs</span>]
            </template>
            <template v-else>
                ${{ letter4.cost }}
            </template>
             to date, and all future costs of this suit, and such other relief the Court does deem just, equitable and proper.
        </p>
        <p>
            <table  cellspacing="0" cellpadding="0" style="width: 100%;border: none;">
                <tr>
                    <td style="border: none;width: 20%;">
                        STATE OF 
                        <template v-if="lodash.isEmpty(letter4.state)">
                            [<span style="background-color: #fbff1d;">State</span>].
                        </template>
                        <template v-else>
                            {{ letter4.state }}.
                        </template>
                    </td>
                    <td style="border: none;">)</td>
                </tr>
                <tr>
                    <td style="border: none;width: 20%;"></td>
                    <td style="border: none;">)</td>
                </tr>
                <tr>
                    <td style="border: none;width: 20%;">
                        <template v-if="lodash.isEmpty(letter4.county)">
                            [<span style="background-color: #fbff1d;">County</span>] COUNTY
                        </template>
                        <template v-else>
                            {{ letter4.county }} COUNTY
                        </template>
                    </td>
                    <td style="border: none;">)</td>
                </tr>
            </table>
        </p>
        <p style="margin-left: 1rem;">
            I, {{ userStore.user.firstname }} {{ userStore.user.lastname }}, swear that the foregoing is a just and true statement of the amount owing by Defendant to Plaintiff, exclusive of all set-offs and just grounds of defense.
        </p>
        <p style="margin-left: 1rem;">
            By affixing this electronic verification, oath, or affidavit to the pleading submitted to the court and attaching my electronic signature hereon, I do hereby swear or affirm that the statements set forth in the above pleading are true and correct.
        </p>
        <p>
            Dated: {{ date }}
        </p>
        <p style="page-break-after: always;">
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            Tel: {{ userStore.user.phone }}
            <br />
            Email: {{ userStore.user.email }}
            <br />
            PLAINTIFF (pro se)
        </p>
        <h3 style="text-align: center;">
            CERTIFICATE OF SERVICE
        </h3>
        <p style="margin-left: 1rem;">
            I certify or affirm that on this date I served Defendant with a courtesy copy of the foregoing Amended Complaint via electronic email to 
            <template v-if="lodash.isEmpty(letter4.email)">
                [<span style="background-color: #fbff1d;">email of attorney or defendant’s rep of record</span>]
            </template>
            <template v-else>
                {{ letter4.email }}
            </template>
             and U.S.P.S. regular mail with sufficient postage thereon to Defendant’s following address:
        </p>
        <p>
            <template v-if="lodash.isEmpty(letter4.attorneyAddress)">
                [<span style="background-color: #fbff1d;">Full name and address of CRA’s attorney or representative of record</span>]
            </template>
            <template v-else>
                {{ letter4.attorneyAddress }}
            </template>
        </p>
        <p>
            Respectfully submitted,
            <br />
            Dated: 
            <template v-if="lodash.isEmpty(letter4.dateSent)">
                [<span style="background-color: #fbff1d;">Date sent</span>]
            </template>
            <template v-else>
                {{ letter4.dateSent }}
            </template>
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../../../stores/ReportStore.js'
    import { useUserStore } from '../../../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            letter4: {
                type: [Array, Object]
            },
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>